import type { SvgIconProps } from 'types/icon';
import ReportProblem from '@mui/icons-material/ReportProblem';
import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined';
import ReportProblemRounded from '@mui/icons-material/ReportProblemRounded';

export const ReportProblemIcon = ({
  color = 'inherit',
  ...props
}: SvgIconProps) => <ReportProblem color={color} {...props} />;

export const ReportProblemOutlinedIcon = ({
  color = 'inherit',
  ...props
}: SvgIconProps) => <ReportProblemOutlined color={color} {...props} />;

export const ReportProblemRoundedIcon = ({
  color = 'inherit',
  ...props
}: SvgIconProps) => <ReportProblemRounded color={color} {...props} />;
